import { Lightning, Lightning as lng, Utils } from '@lightningjs/sdk';
import { Theme } from '../../config/theme';
import { _constants } from './ZappingBar';
import { fullUrlWithRecipe, Recipes } from '../../Business/utility/ImageRecipeUtil';

export class ZappingBarCard extends lng.Component {
  static _template() {
    return {
      w: _constants.zappingBarWidth,
      h: _constants.channelCardHeight,
      Background: {
        w: w => w,
        h: h => h,
        rect: true,
        shader: {
          type: Lightning.shaders.RoundedRectangle,
          radius: _constants.channelCardCornerRadius,
        },
        colorLeft: Theme.Colors.Black,
        colorRight: Theme.Colors.CmsZappingBar.CardSecondary,
      },
      ChannelNumber: {
        x: _constants.leftPadding,
        y: _constants.verticalPaddingFavorite,
        mountX: 0.5,
        text: {
          text: 'Channel Number',
          textAlign: 'center',
        },
      },
      ChannelFavorite: {
        x: _constants.leftPadding,
        y: h => h - _constants.verticalPaddingFavorite,
        mountY: 1,
        mountX: 0.5,
      },
      ChannelImage: {
        mountX: 1,
        x: w => w - _constants.rightPadding,
        y: _constants.verticalPadding,
        h: h => h - _constants.verticalPadding * 2,
        w: _constants.maxImageWidth,
        Contain: {
          x: w => w / 2,
          y: h => h / 2,
          mount: 0.5,
          texture: {
            type: lng.textures.ImageTexture,
            src: '',
            resizeMode: {
              type: 'contain',
              w: _constants.maxImageWidth,
              h: _constants.channelCardHeight - _constants.verticalPadding * 2,
            },
          },
        },
      },
      ChannelTitle: {
        mountX: 1,
        mountY: 0.5,
        x: w => w - _constants.rightPadding,
        y: h => h / 2,
        // h: h => h - _constants.verticalPadding * 2,
        w: _constants.maxTextWidth,
        visible: false,
        font: Theme.Fonts.Detail.Title,
        fontSize: 12,
        text: {
          text: 'Channel Title',
          maxLines: 2,
          textAlign: 'center',
          verticalAlign: 'middle',
        },
      },
    };
  }
  _init() {
    this._isFavorite = false;
    this.tag('ChannelNumber').text.text = this.channelModel.channelNumber;

    if (this.channelModel.image.squareLogo) {
      const imageUrl = fullUrlWithRecipe(this.backend, this.channelModel.image.squareLogo, Recipes.MediumChannelLogo); // logo options defaultLogo, posterLogo, squareLogo
      // console.log(imageUrl);
      this.tag('Contain').texture.src = imageUrl;
    } else {
      this.tag('ChannelTitle').text.text = this.channelModel.text.title;
      this.tag('ChannelTitle').visible = true;
    }
  }

  _focus() {
    this.tag('Background').setSmooth('colorRight', Theme.Colors.CmsZappingBar.CardPrimary);
  }

  _unfocus() {
    this.tag('Background').setSmooth('colorRight', Theme.Colors.CmsZappingBar.CardSecondary);
  }

  get channelID() {
    return this.channelModel.channelId;
  }

  set favorite(fav) {
    this._isFavorite = fav;
    if (fav) {
      this.tag('ChannelFavorite').patch({ color: Theme.Colors.Primary });
      this.tag('ChannelFavorite').src = Utils.asset('images/guide/ic_star.png');
    } else {
      this.tag('ChannelFavorite').patch({ color: Theme.Colors.White });
      this.tag('ChannelFavorite').src = Utils.asset('images/guide/ic_star.png');
    }
  }

  get isFavorite() {
    return this._isFavorite;
  }
}
